import './polyfills.ts';

import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

if (environment.production) {
    enableProdMode();

	// disable console logs
	//window.console.log = function() { };
}

platformBrowserDynamic().bootstrapModule(AppModule);